module.exports = [{
      plugin: require('/Users/matt/Projekty/joanna-cleaning-service/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
